module.exports = __webpack_public_path__ + "static/media/social.692d8337.svg";